module.exports = __webpack_public_path__ + "img/icon-24-ic-arrow-w.a5207502.svg";